// src/pages/LoginPage.jsx

import React, { useEffect, useState, useCallback } from "react";
import { Password } from "../constant";
import { useNavigate } from "react-router-dom";
import API from "../services/API";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const LoginPage = () => {
  const navigate = useNavigate();
  const [state, setState] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const getToken = useCallback(async () => {
    try {
      const jwt_token = localStorage.getItem("token");
      if (!jwt_token) return;

      const headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
        token: jwt_token,
      };

      const response = await API.get("/schoolStaff/checkToken", { headers });

      if (response?.data?.response_code === 1000) {
        navigate("/dashboard");
      }
    } catch (err) {
      console.error("checkToken error:", err);
    }
  }, [navigate]);

  useEffect(() => {
    getToken();
  }, [getToken]);

  const onChange = (field, event) => {
    setState((prev) => ({ ...prev, [field]: event.target.value }));
  };

  const handleSubmit = async (e) => {
    e?.preventDefault();
    if (loading) return;

    if (!state.email || !state.password) {
      toast.error("Sila masukkan emel dan kata laluan.", { autoClose: 4000 });
      return;
    }

    setLoading(true);

    try {
      const response = await API.post("/schoolStaff/login", {
        email: state.email,
        password: state.password,
      });

      const { data } = response || {};

      if (data?.response_code === 1000) {
        localStorage.setItem("token", data?.data?.token || "");
        localStorage.setItem("full_name", data?.data?.full_name || "");
        localStorage.setItem("school_name", data?.data?.school_name || "");
        localStorage.setItem("role", data?.data?.role || "");
        localStorage.setItem("school_logo_url", data?.data?.logo || "");

        toast.success("Berjaya log masuk.", { autoClose: 1500 });
        navigate("/dashboard");
      } else {
        toast.error(data?.message || "Log masuk gagal.", { autoClose: 5000 });
      }
    } catch (err) {
      const msg =
        err?.response?.data?.message ||
        err?.message ||
        "Tidak dapat menghubungi pelayan.";
      toast.error(msg, { autoClose: 5000 });
    } finally {
      setLoading(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") handleSubmit(e);
  };

  return (
    <>
      <style>{`
        :root {
          --spgov-navy: #0b192c;
          --spgov-blue: #1e3a8a;
          --spgov-blue-hover: #1d4ed8;
          --spgov-bg: #f8fafc;
          --spgov-card: #ffffff;
          --spgov-text: #0f172a;
          --spgov-muted: #64748b;
          --spgov-border: #e2e8f0;
          --spgov-gold: #d97706;
        }

        * {
          box-sizing: border-box;
          margin: 0;
          padding: 0;
        }

        .spgov-login-page {
          min-height: 100vh;
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: var(--spgov-bg);
          background-image: 
            radial-gradient(circle at 10% 20%, rgba(30, 58, 138, 0.05) 0%, transparent 40%),
            radial-gradient(circle at 90% 80%, rgba(217, 119, 6, 0.03) 0%, transparent 40%);
          color: var(--spgov-text);
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
          padding: 24px;
        }

        .spgov-login-container {
          width: 100%;
          max-width: 460px;
          display: flex;
          flex-direction: column;
          gap: 24px;
        }

        .spgov-brand-center {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 12px;
          text-align: center;
        }

        .spgov-logo {
          width: 56px;
          height: 56px;
          border-radius: 16px;
          display: grid;
          place-items: center;
          background: var(--spgov-navy);
          color: #ffffff;
          font-size: 20px;
          font-weight: 800;
          letter-spacing: -0.04em;
          box-shadow: 0 10px 25px -5px rgba(11, 25, 44, 0.2);
        }

        .spgov-brand-copy strong {
          font-size: 22px;
          font-weight: 800;
          letter-spacing: -0.03em;
          color: var(--spgov-navy);
        }

        .spgov-brand-copy span {
          display: block;
          margin-top: 2px;
          color: var(--spgov-muted);
          font-size: 11px;
          font-weight: 700;
          letter-spacing: 0.1em;
          text-transform: uppercase;
        }

        .spgov-login-card {
          overflow: hidden;
          border-radius: 24px;
          border: 1px solid var(--spgov-border);
          background: var(--spgov-card);
          box-shadow:
            0 20px 25px -5px rgba(0, 0, 0, 0.05),
            0 10px 10px -5px rgba(0, 0, 0, 0.02);
        }

        .spgov-login-header {
          padding: 40px 40px 0px;
          text-align: center;
        }

        .spgov-login-kicker {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          margin-bottom: 12px;
          color: var(--spgov-gold);
          font-size: 11px;
          font-weight: 700;
          letter-spacing: 0.08em;
          text-transform: uppercase;
        }

        .spgov-login-header h2 {
          color: var(--spgov-navy);
          font-size: 26px;
          font-weight: 800;
          letter-spacing: -0.03em;
          line-height: 1.2;
        }

        .spgov-login-header p {
          margin-top: 8px;
          color: var(--spgov-muted);
          font-size: 14px;
          line-height: 1.5;
        }

        .spgov-login-form {
          padding: 32px 40px;
        }

        .spgov-field {
          margin-bottom: 20px;
        }

        .spgov-field label {
          display: block;
          margin-bottom: 6px;
          color: var(--spgov-text);
          font-size: 13px;
          font-weight: 600;
        }

        .spgov-input {
          width: 100%;
          height: 48px;
          padding: 0 16px;
          border-radius: 12px;
          border: 1px solid var(--spgov-border);
          background: #ffffff;
          color: var(--spgov-text);
          outline: none;
          font-size: 14px;
          transition: all 0.15s ease;
        }

        .spgov-input::placeholder {
          color: #94a3b8;
        }

        .spgov-input:focus {
          border-color: var(--spgov-blue);
          box-shadow: 0 0 0 4px rgba(30, 58, 138, 0.08);
        }

        .spgov-submit {
          width: 100%;
          height: 48px;
          margin-top: 8px;
          border: none;
          border-radius: 12px;
          color: #ffffff;
          background: var(--spgov-navy);
          font-size: 14px;
          font-weight: 700;
          letter-spacing: 0.02em;
          cursor: pointer;
          transition: all 0.15s ease;
        }

        .spgov-submit:hover {
          background: var(--spgov-blue-hover);
          transform: translateY(-1px);
        }

        .spgov-submit:disabled {
          opacity: 0.6;
          cursor: not-allowed;
          transform: none;
        }

        .spgov-actions {
          margin-top: 16px;
          display: flex;
          justify-content: center;
        }

        .spgov-link-button {
          border: none;
          background: transparent;
          color: var(--spgov-blue);
          font-size: 13px;
          font-weight: 600;
          cursor: pointer;
        }

        .spgov-link-button:hover {
          color: var(--spgov-blue-hover);
          text-decoration: underline;
        }

        .spgov-security-note {
          margin-top: 24px;
          padding: 12px 16px;
          border-radius: 12px;
          background: #f1f5f9;
          color: var(--spgov-muted);
          font-size: 12px;
          line-height: 1.5;
        }

        .spgov-security-note strong {
          display: block;
          color: var(--spgov-navy);
          margin-bottom: 2px;
        }

        .spgov-card-footer {
          padding: 20px 40px;
          text-align: center;
          border-top: 1px solid var(--spgov-border);
          background: #fafafa;
          color: var(--spgov-muted);
          font-size: 12px;
          line-height: 1.5;
        }

        @media (max-width: 480px) {
          .spgov-login-page {
            padding: 16px;
          }
          .spgov-login-header {
            padding: 32px 24px 0px;
          }
          .spgov-login-form {
            padding: 24px 24px 32px;
          }
          .spgov-card-footer {
            padding: 20px 24px;
          }
        }
      `}</style>

      <div className="spgov-login-page">
        <div className="spgov-login-container">
          
          <header className="spgov-brand-center">
            <div className="spgov-logo" aria-label="SPGO.my">
              SP
            </div>
            <div className="spgov-brand-copy">
              <strong>SPGO.my</strong>
              <span>Government Portal</span>
            </div>
          </header>

          <main className="spgov-login-card">
            <div className="spgov-login-header">
              <div className="spgov-login-kicker">Secure Access</div>
              <h2>Access Your Account</h2>
              <p>
                Enter your registered credentials to continue to the administration console.
              </p>
            </div>

            <form className="spgov-login-form" onSubmit={handleSubmit}>
              <div className="spgov-field">
                <label htmlFor="email">Email Address</label>
                <input
                  id="email"
                  className="spgov-input"
                  type="email"
                  value={state.email}
                  onChange={(e) => onChange("email", e)}
                  placeholder="name@agency.gov.my"
                  autoComplete="email"
                />
              </div>

              <div className="spgov-field">
                <label htmlFor="password">{Password}</label>
                <input
                  id="password"
                  className="spgov-input"
                  type="password"
                  value={state.password}
                  onChange={(e) => onChange("password", e)}
                  onKeyDown={handleKeyDown}
                  placeholder="Enter your password"
                  autoComplete="current-password"
                />
              </div>

              <button className="spgov-submit" type="submit" disabled={loading}>
                {loading ? "VERIFYING..." : "SIGN IN"}
              </button>

              <div className="spgov-actions">
                <button
                  className="spgov-link-button"
                  type="button"
                  onClick={() => navigate("/forgot-password")}
                >
                  Forgot password?
                </button>
              </div>

              <div className="spgov-security-note">
                <strong>Restricted Access Notice</strong>
                This system is intended for authorised personnel only. Access
                attempts and user activity are recorded for security and compliance purposes.
              </div>
            </form>

            <footer className="spgov-card-footer">
              For account access issues, please contact your appointed system
              administrator or agency support officer.
            </footer>
          </main>
          
        </div>

        <ToastContainer
          position="top-right"
          autoClose={4000}
          newestOnTop
          closeOnClick
          pauseOnHover
          draggable
          theme="colored"
        />
      </div>
    </>
  );
};

export default LoginPage;